import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';

export const SearchNavItemMobile = ({ showForm, onClick }) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      aria-pressed={showForm}
      aria-label={showForm ? t('search.close_button.label') : t('search.open_button.label')}
      className={`ct-search-nav-item-mobile${
        !showForm ? ' ct-search-nav-item-mobile--search-icon' : ' ct-search-nav-item-mobile--close-icon'
      }`}
      onClick={onClick}
    >
      {!showForm ? (
        <FontAwesomeIcon icon={faSearch} />
      ) : (
        <div className="close-icon__extension">
          <FontAwesomeIcon icon={faTimes} />
        </div>
      )}
    </button>
  );
};
